<template>
  <input
    type="text"
    @focus="resetSelectedProduct"
    class="form-control"
    readonly
    v-model="placeholder"
    id=""
    v-if="selectedProduct"
  />

    <!-- @keyup.enter.stop.native="addNewProduct" -->
  <el-select
    v-else
    :select-when-unmatched='true'
  
    @change="productSelected"
    class="search faturaQuery darkBorder"
    @focus="options = []"
    v-model="value"
    :loading-text="loadingMsg"
    :no-data-text="noDataMsg"
    filterable
    remote
    :clearable="true"
    placeholder="بحث المنتجات بالاسم"
    :remote-method="remoteMethod"
    :loading="loading" 
  >
   
    <el-option
      ref="faturaQuery"
      v-for="(item, index) in options"
      :key="index"
      :label="item.name"
      :value="item.id"
    >
   {{ item.name }}
    </el-option>
    <el-option  value="0">اقترح على فاتورة</el-option>
  </el-select>
</template>

<script>
import axiosApi from "@/plugins/axios.js";

export default {
  props: ["supplier", "showStockZero"],

  data() {
    return {
      noDataMsg: "لا توجد بيانات متاحه",
      loadingMsg: " ... جاري تحميل البيانات",
      options: [],
      placeholder: "",
      selectedLabel: "",

      value: null,
      loading: false,
      selectedProduct: null,
    };
  },
  mounted() {},
  methods: {
    
    addNewProduct(){
      if(this.selectedProduct ==null){
         this.$emit("searchFaturaProducts", {
           product: {'name':this.selectedLabel,'id':0},
           exist:false,

                
              });
      }
    },
    setValue(value,query) {
      this.selectedProduct = value;
      if (this.value != null) {
        this.value = value;
        this.placeholder = value.name;
      } else {
        this.placeholder = "";
         document.querySelector(".faturaQuery input").value=query;
document.querySelector(".faturaQuery input").focus();
this.remoteMethod(query);
     

      }
    },
    resetSelectedProduct() {
      this.selectedProduct = null;
      this.value = null;
      this.placeholder = "";
      this.$emit("resetFaturaSearch");
     
    },
    productSelected() {
      this.selectedProduct=null;
      if(this.value>0){
      this.selectedProduct = this.options.filter((product) => {
        if (product.id == this.value) {
          return product;
        }
      })[0];
        this.setValue(this.selectedProduct,"")
          console.log("productSelected", this.selectedProduct);

      if(this.selectedProduct.providers.length>0){
        console.log("coded before")

         axiosApi
            .get(`products/barcode-search/${this.selectedProduct.providers[0].code}`)
            .then((res) => {

             this.$emit("searchFaturaProducts", {
           product: res.data[0],
           exist:true,
                
              });
          
            })
            .catch((e) => {
              console.log(e);
                console.log("not coded")
          this.$emit("searchFaturaProducts", {
           product: this.selectedProduct,
           exist:false,

                
              });

            });
      }else{
        console.log("not coded")
          this.$emit("searchFaturaProducts", {
           product: this.selectedProduct,
           exist:false,

                
              });
            
      }
    }else{
      this.value=this.selectedLabel;
       this.$emit("searchFaturaProducts", {
           product: {'name':this.selectedLabel,'id':0},
           exist:false,

                
              });
     
    }
     
    },
    remoteMethod(query) {
        if (query !== "") {
          this.selectedLabel = query;
          this.$emit("faturaQueryChange", {
            faturaQuery: this.selectedLabel,
          });
          this.loading = true;
          axiosApi
            .get(
              `products/fatura?name=${query}`
            )
            .then((res) => {
              this.loading = false;
              this.options = res.data.products;
            })
            .catch((e) => {
              this.loading = false;

              console.log(e);
            });
        } else {
          this.options = [];
        }
    
    },
  },
};
</script>